<template>
  <div class="create-user" v-show="seen">
    <div class="adduser animated slideInDown">
      <h4 class="d-flex flex-row justify-content-between">
        <span style="font-size: 16px; font-weight: normal; color: #111111">
          <strong>Add User</strong>
        </span>
        <span class="close-modal" @click="close">
          <img src="@/assets/Close.svg" />
        </span>
      </h4>
      <form>
        <div class="input">
          <div>
            <label class="mb-2">First Name</label>
            <input
              type="text"
              v-model="first_name"
              placeholder="Enter first name"
            />
            <span class="error" v-if="error.first_name">*Required</span>
          </div>
          <div style="margin-left: 0.9em">
            <label class="mb-2">Last Name</label>
            <input
              type="text"
              v-model="last_name"
              placeholder="Enter last name"
            />
            <span class="error" v-if="error.last_name">*Required</span>
          </div>
        </div>
        <div class="input nott">
          <div>
            <label class="mb-2">Email Address</label>
            <input type="text" v-model="email" placeholder="Enter email" />
            <span class="error" v-if="error.email">*Required</span><br />
            <span class="error" v-if="error.format">Invalid email address</span>
            <span class="error" v-if="error.user_email_exist"
              >Email address already in use</span
            >
          </div>
          <div>
            <label class="mb-2">Phone</label>
            <input type="text" v-model="phone" placeholder="Enter phone" />
          </div>
        </div>
        <div class="input not">
          <div>
            <label class="mb-2">Department</label>
            <select v-model="department">
              <option value="">Select Department</option>
              <option
                v-for="(department, index) in departments"
                :value="department._id"
                :key="index"
              >
                {{ department.name }}
              </option>
            </select>
            <span class="error" v-if="error.user_department">*Required</span>
          </div>
        </div>
        <div class="input space">
          <label class="mb-2">Allocate Space to User</label>
          <div>
            <input
              type="number"
              style="width: auto"
              v-model="size"
              value="100"
              :disabled="is_disable"
              @blur="check_space_allocated"
              @input="check_space"
              @change="check_space"
            />
            <select
              style="padding: 0.6em 1em"
              v-model="unit"
              @change="check_unit"
              :disabled="is_disable"
            >
              <option value="MB">MB</option>
              <option value="GB">GB</option>
            </select>
            &nbsp;&nbsp;
            <label class="unlimited_label"
              ><input
                type="checkbox"
                style="width: auto"
                v-model="is_disable"
              />
              Unlimited</label
            >
          </div>
        </div>
        <div class="input admin">
          <label class="d-inline-flex align-items-center">
            <input type="checkbox" v-model="is_admin" />
            <span title="Make this user admin">
              Is Admin
              <svg style="width: 14px; height: 14px" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                />
              </svg>
            </span>
          </label>
        </div>
        <div class="storage">
          <span class="">
            <img src="@/assets/bi_cloud-check-fill.svg" />
          </span>
          <span class="storage-bar">
            <span>
              <span
                :style="{
                  width: (total_space_used / total_space) * 100 + '%',
                  display: 'block',
                }"
              ></span>
            </span>
            <span class="d-flex justify-content-between flex-row">
              <span
                >Storage ({{
                  Math.ceil((total_space_used / total_space) * 100)
                }}% full)</span
              >
              <span
                >{{ $sizeFormat(total_space_used) }} of
                {{ $sizeFormat(total_space) }}</span
              >
            </span>
          </span>
        </div>
        <div class="submit">
          <button type="button" @click="add_user">
            <img src="@/assets/Plus.svg" />&nbsp;&nbsp; Add User
          </button>
        </div>
      </form>
    </div>
    <warning ref="warning"></warning>
    <loading ref="loading"></loading>
  </div>
</template>
<style scoped>
.error {
  font-size: 14px;
  color: #fc6d6c;
}
.unlimited_label {
  display: flex;
  align-items: center;
}
.space {
  display: flex;
  flex-direction: column !important;
}
.space div input {
  margin-right: 0.6em;
}
.space div select {
  width: 100px;
  margin-right: 0.6em;
}
.adduser h3 {
  font-size: 24px;
  border-bottom: 1px solid #e9e9e9;
  margin-bottom: 0.8em;
}
.close-modal {
  cursor: pointer;
  background-color: #f2f7fc;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
}
.close {
  position: absolute;
  right: 12px;
  top: 10px;
  cursor: pointer;
}
.admin label {
  display: flex;
}
.admin label input {
  margin-right: 0.6em;
  width: auto;
}
.admin label span {
  width: auto;
}
.input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.5em;
}
.leave {
  display: block !important;
}
.input label {
  margin-bottom: 0;
}
.input input {
  background-color: rgb(250, 250, 250);
  border: 1px solid #f1f1f1;
  border-radius: 3px;
  text-align: left;
  padding: 0.3em 0.4em;
  width: 100%;
}
.input > div {
  flex-grow: 1;
  width: 50%;
}
.space div {
  display: flex;
  flex-direction: row !important;
  width: 100%;
}
.nott div:last-child {
  margin-left: 1em;
}
.not div {
  display: flex;
  flex-direction: column !important;
  width: 98%;
}
div select {
  background-color: rgb(250, 250, 250);
  border: 1px solid #f1f1f1;
  border-radius: 3px;
  text-align: left;
  padding: 0.5em 0.6em;
  font-size: 15px !important;
  outline-style: none;
  width: 98%;
}
</style>

<script>
import AuthenticationService from "@/services/AuthenticationService";
import { mapMutations } from "vuex";
import loading from "@/components/Loading";
import warning from "@/components/Warning";
import cookies from "@/services/cookies";

export default {
  components: {
    warning,
    loading,
  },
  data() {
    return {
      seen: false,
      type: "",
      title: "",
      filename: "",
      loader: false,
      specialChar_error: "",
      exist: false,
      total_space_remaining: 0,
      total_space_used: 0,
      total_space: 0,
      total_user_used_space: 0,
      tag: 0,
      size: 100,
      is_disable: false,
      unit: "MB",
      department: "",
      departments: [],
      last_name: "",
      first_name: "",
      email: "",
      password: "",
      con_password: "",
      phone: "",
      is_admin: false,
      str: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      error: {
        password: false,
        con_password: false,
        first_name: false,
        last_name: false,
        format: false,
        email: false,
        password_length: false,
        con_password_length: false,
        user_department: false,
        user_email_exist: false,
      },
      post: true,
    };
  },
  methods: {
    revertSize() {
      this.size = 100;
    },
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "UPDATE_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SORT_DIRECTORY_CHILDREN",
      "UPDATE_TOTAL_USED_SPACE",
    ]),
    useradded() {
      this.$parent.useradded();
    },
    adduser(data, unit, size, is_disable, is_admin) {
      this.$parent.add_new_user(data, unit, size, is_disable, is_admin);
    },
    logincall() {
      this.$parent.logincall();
    },
    check_space_allocated() {
      if (this.unit == "MB") {
        // If allocated size is less than 100MB
        if (1048576 * this.size < 104857600) {
          this.$refs.warning.load("less");
          this.size = 100;
          return;
        }
      }

      if (this.unit == "GB") {
        if (this.total_space < 1073741824 * this.size) {
          this.$refs.warning.load("high", this.total_space);
        }
      }
    },
    totalspaceremaining() {
      if (this.total_space_used > this.total_space) {
        return 0;
      } else {
        return this.total_space - this.total_space_used;
      }
    },
    totalspaceused() {
      this.total_space_used = this.total_user_used_space + 1048576 * this.size;
    },
    check_unit() {
      if (this.unit === "MB") {
        this.total_space_used =
          this.total_user_used_space + 1048576 * this.size;
      } else {
        this.total_space_used =
          this.total_user_used_space + 1073741824 * this.size;
      }
    },
    low_warning() {
      this.$refs.warning.load("low");
    },
    high_warning() {
      this.$refs.warning.load("high", this.total_space);
    },
    check_space(evt) {
      // let size = this.$spaceFormat(this.total_space, this.size, this.unit)

      if (this.unit == "MB") {
        // If allocated size is less than 100MB
        // this.total_space_remaining = this.totalspaceremaining()
        // this.totalspaceused()
        this.total_space_used =
          this.total_user_used_space + 1048576 * this.size;
      }

      if (this.unit == "GB") {
        // this.total_space_remaining = this.totalspaceremaining()
        // this.totalspaceused()
        this.total_space_used =
          this.total_user_used_space + 1073741824 * this.size;
      }
    },
    add_user() {
      this.post = true;
      this.user_email_exist = false;

      if (this.first_name == "") {
        this.error.first_name = true;
        this.post = false;
      } else {
        this.error.first_name = false;
      }

      if (this.last_name == "") {
        this.error.last_name = true;
        this.post = false;
      } else {
        this.error.last_name = false;
      }

      if (this.email == "") {
        this.error.email = true;
        this.post = false;
      } else {
        this.error.email = false;

        if (this.str.test(this.email) === false) {
          this.error.format = true;
          this.post = false;
        } else {
          this.error.format = false;
        }
      }

      if (this.departments.length) {
        if (this.department == "") {
          this.error.user_department = true;
          this.post = false;
        } else {
          this.error.user_department = false;
        }
      } else {
        this.error.user_department = true;
        this.post = false;
      }

      if (this.post === true) {
        this.$refs.loading.load();

        let that = this;

        let data = {
          token: cookies.getCookie("temp_token"),
          email: this.email,
          firstname: this.first_name,
          lastname: this.last_name,
          phone: this.phone,
          department: this.department,
          is_admin: this.is_admin,
          size: this.is_disable ? "Unlimited" : this.size,
          unit: this.unit,
        };

        AuthenticationService.create_user(data)
          .then((res) => {
            if (res.data.data === true) {
              that.$refs.loading.close();
              that.seen = false;
              // that.useradded()

              that.adduser(
                res.data.user,
                that.unit,
                that.size,
                that.is_disable,
                that.is_admin
              );

              that.email = "";
              that.first_name = "";
              that.last_name = "";
              that.phone = "";
              that.user_department = "";
              that.is_disable = false;
              that.password = "";
              that.con_password = "";
              that.is_admin = false;
              that.size = 100;
              that.unit = "MB";
            }

            if (res.data.error == true) {
              that.$refs.loading.close();
              that.error.user_email_exist = true;
            }

            if (res.data.data == false) {
              that.$refs.loading.close();
              that.seen = false;
              that.logincall();
              that.$router.push('/login')
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    load() {
      this.seen = true;
      let that = this;

      this.$socket.emit(
        "get-departments",
        { token: cookies.getCookie("temp_token") },
        function (data) {
          if (data.data === true) {
            that.departments = data.departments;
          }
        }
      );

      this.email = "";
      this.first_name = "";
      this.last_name = "";
      this.phone = "";
      this.user_department = "";
      this.is_disable = false;
      this.password = "";
      this.con_password = "";
      this.size = 100;
      this.is_admin = false;
      this.unit = "MB";

      this.error.password = false;
      this.error.con_password = false;
      this.error.first_name = false;
      this.error.last_name = false;
      this.error.format = false;
      this.error.email = false;
      this.error.password_length = false;
      this.error.con_password_length = false;
      this.error.user_department = false;
      this.error.user_email_exist = false;

      this.$socket.emit(
        "total-allocated-space",
        { token: cookies.getCookie("temp_token") },
        function (data) {
          if (data.data === true) {
            that.tag = data.tag;
            that.total_space = data.total_space;
            that.total_space_remaining = data.total_remaining_space;
            that.total_space_used =
              data.total_allocated_space + 1048576 * that.size;
            that.total_user_used_space = data.total_allocated_space;
          }

          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }
        }
      );
    },
    close() {
      this.seen = false;
      this.loader = false;
    },
  },
  mounted() {
    let that = this;
  },
};
</script>
